import axios from 'axios'
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
} from '@aws-sdk/client-cognito-identity-provider'
import AuthSession from 'admin/utils/AuthSession'
import { AccountAssumption } from 'admin/utils/AccountAssumption'
import { CLIENT_ID } from 'components/Login/ConfigLoader'
import {
  refreshCognitoAccessToken,
  getValidAccessToken,
} from 'utils/aws/authService'
import { getApiUrl } from './getApiUrl'

const apiUrl = getApiUrl()
const apiClient = axios.create({
  baseURL: apiUrl, // Your API Gateway base URL
})

//New method
apiClient.interceptors.request.use(
  async (config) => {
    const token = await getValidAccessToken()
    config.headers['Authorization'] = `Bearer ${token}`
    config.headers['assumed-user'] = await AccountAssumption.assumedAs()
    return config
  },
  (error) => Promise.reject(error)
)

//New method
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      try {
        const newToken = await refreshCognitoAccessToken()
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`
        return apiClient(originalRequest)
      } catch (err) {
        console.error('Token refresh failed during retry:', err)
      }
    }

    return Promise.reject(error)
  }
)
export { apiClient }
// Export your apiClient for use in your app
// export default apiClient
